// DEPRECATED
const Config = {
  // originalEvents
  showEvent   : 'show',
  shownEvent  : 'shown',
  hideEvent   : 'hide',
  hiddenEvent : 'hidden',
  closeEvent  : 'close',
  closedEvent : 'closed',


  CollapseClassName : {
    IN: 'in',
    BASE: 'collapse',
    COLLAPSING: 'collapsing',
    COLLAPSED: 'collapsed',
    WIDTH: 'width',
    SHOWN: 'show'
  }

};

export default Config;
